import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsPage } from "@/components/analytics/AnalyticsPage";

export const Route = createFileRoute("/dashboard/w/$workspaceId/analytics")({
  component: AnalyticsRoute,
});

function AnalyticsRoute() {
  const { workspaceId } = Route.useParams();
  return <AnalyticsPage workspaceId={workspaceId} />;
}
